import React, {Component} from 'react'
import {Stages} from 'components'
import {Disclaimer, Certification, Unsupported} from 'components/account'

export class Preview extends Component {
  state = {}

  get disclaimer() {
    return `${this.props.country.disclaimer || ''}\n${this.props.riskDisclaimer.content}`
  }

  render = () =>
    <Stages context={{country: this.props.country, metCertificationItems: [], disclaimer: this.disclaimer}}
            onStageChange={stage => this.setState({stage})} stage={this.state.stage}>
      <Disclaimer />
      <Certification title={`${this.props.country.certificationHeading}: ${this.props.country.name}`} hidden={!this.props.country.supported} />
      <Unsupported hidden={this.props.country.supported}/>
    </Stages>
}

export default Preview